import {RestrictionItem} from '@app/core/model/filtering/restriction-item';
import {RestrictionRule} from '@app/core/model/filtering/restriction-rule';
import {AttributeEntityItem, OneAttributeEntity, RequestedPropertyModel} from '@app/core/model/integration-models';
import {PredicateModel} from '@app/core/model/filtering/predicate-model';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';
import {AttributeType} from '@app/core/model/filtering/filter-predicate';

export class RestrictionFilter implements RestrictionItem {
    rule: RestrictionRule;
    entity: OneAttributeEntity;
    _predicate: PredicateModel;
    _value: any;
    uniqId: string;
    modifiedBy: RequestedPropertyModel;

    static isEqual(a: RestrictionFilter, b: RestrictionFilter): boolean {
        return a && b && (
            (!!a.rule === !!b.rule)
            && (!a.rule || RestrictionRule.isEqual(a.rule, b.rule))
            && (!!a.entity === !!b.entity)
            && (!a.entity || OneAttributeEntity.isEqual(a.entity, b.entity))
            && (a.value === b.value)
            && (!!a.predicate === !!b.predicate)
            && (!a.predicate || PredicateModel.isEqual(a.predicate, b.predicate))
            && (!!a.modifiedBy === !!b.modifiedBy)
            && (!a.modifiedBy || RequestedPropertyModel.isEqual(a.modifiedBy, b.modifiedBy))
            && (a.uniqId === b.uniqId)
            && (a.integrationId === b.integrationId)
        );
    }

    constructor(
        public predicatesMetadata: MetadataModel[],
        public integrationId: string
    ) {
        this.uniqId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    set value(value: any) {
        this._value = value;
    }

    get value(): any {
        return this._value;
    }

    set predicate(predicate: PredicateModel) {
        this._predicate = predicate;
    }

    get predicate(): PredicateModel {
        return this._predicate;
    }

    set attribute(attribute: AttributeEntityItem) {
        if (this.entity) {
            this.entity.attribute = attribute;
        }
    }

    get attribute(): AttributeEntityItem {
        if (this.entity) {
            return this.entity.attribute;
        }
        return undefined;
    }

    getAvailablePredicates(type: AttributeType = AttributeType.STRING): PredicateModel[] {
        if (!this.predicatesMetadata) {
            return [];
        }
        const predicateMetadata = this.predicatesMetadata.find(it => it.type === type)
            || this.predicatesMetadata.find(it => it.type === AttributeType.STRING);
        return predicateMetadata ? predicateMetadata.predicates : [];
    }

    isCompleted(oldValue?: string): boolean {
        const value = oldValue ? oldValue : this.value;
        return !!this.entity
            && !!this.entity.attribute
            && (!this.entity.attribute.isExtensionField || this.entity.attribute.extensionPropertyName)
            && !!this.predicate
            && ((this.predicate.isRequireArguments && value) || !this.predicate.isRequireArguments);
    }

    equals(filter: RestrictionFilter): boolean {
        return RestrictionFilter.isEqual(this, filter);
    }
}
